import {
  ChangeDetectionStrategy,
  Component,
} from '@angular/core';
import { MwcButtonModule } from 'mwc/button';
import { CommonModule } from '@angular/common';
import { StorageHelper } from '../_utilities/storage-helper';
import { Router } from '@angular/router';
import { lastValueFrom } from 'rxjs';
import { TokenService } from '../services/token/token.service';

@Component({
  selector: 'app-session-expired',
  standalone: true,
  imports: [CommonModule, MwcButtonModule],
  templateUrl: './session-expired.component.html',
  styleUrls: ['./session-expired.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SessionExpiredComponent {
  private _storageHelper: StorageHelper;
  constructor(private router: Router, private tokenService: TokenService) {
      this._storageHelper = new StorageHelper();
  }

  async login(): Promise<void> {
    // Capture the base URL before clearing the now-dead local session.
    const returnUrl = this._storageHelper.user?.returnUrl || '';
    this._storageHelper.clear();
    sessionStorage.removeItem('siteConfig');

    if (returnUrl) {
      window.location.href = `${returnUrl}account/login`;
      return;
    }

    // No stored returnUrl (e.g. the user arrived from an email CTA without ever
    // logging in). Fetch the login URL from the anonymous auth endpoint, which
    // falls back to the configured MPC base URL.
    try {
      const result = await lastValueFrom(this.tokenService.getBaseReturnUrl());
      if (result?.url) {
        window.location.href = result.url;
        return;
      }
    } catch (error) {
      console.error('Failed to fetch return url:', error);
    }
    this.router.navigate(['auth']);
  }
}
